import { createAction } from 'utils/reduxHelpers';
import * as actionTypes from './actionTypes';
import { WebhookParamProps } from './types';

export const createSystemWebhookRequest = (
  params: Pick<WebhookParamProps, 'endpoint' | 'authToken' | 'authType'>,
) => ({
  type: actionTypes.CREATE_SYSTEM_WEBHOOK_REQUEST,
  params,
});

export const createSystemWebhookResponse = createAction(actionTypes.CREATE_SYSTEM_WEBHOOK_RESPONSE);

export const deleteSystemWebhookRequest = (id: number) => ({
  type: actionTypes.DELETE_SYSTEM_WEBHOOK_REQUEST,
  id,
});

export const fetchSystemWebhooksRequest = () => ({
  type: actionTypes.FETCH_SYSTEM_WEBHOOKS_REQUEST,
});

export const fetchSystemWebhooksResponse = (response: WebhookParamProps[]) => ({
  type: actionTypes.FETCH_SYSTEM_WEBHOOKS_RESPONSE,
  response,
});

export const handleSystemWebhooksError = createAction(actionTypes.SYSTEM_WEBHOOK_ERROR);

export const updateSystemWebhookRequest = (params: WebhookParamProps) => ({
  type: actionTypes.UPDATE_SYSTEM_WEBHOOK_REQUEST,
  params,
});

export const validateSystemWebhookRequest = createAction(
  actionTypes.VALIDATE_SYSTEM_WEBHOOK_REQUEST,
);
